// extracted by mini-css-extract-plugin
export default {"disableLink":"Ho-z"};